import React from 'react';
import ProgressBarStep from './ProgressBarStep';
import Container from './ProgressBarStepperV2.styles';
import {} from './ProgressBarStepperV2.types';
const ProgressBarStepperV2 = ({ steps, onClickStep, customStatus }) => (React.createElement(Container, null, steps.map((step) => (React.createElement(ProgressBarStep, { customStatus: customStatus, key: `step-${step.id}`, onClickStep: onClickStep, step: step })))));
export default ProgressBarStepperV2;
